import React from 'react';
import SEOImage from '../assets/img/SEO_image.png';

const DEFAULTS = {
  description:
    'Farmer’s Fridge sells fresh and healthy food through a user-friendly, self-serve smart Fridge. We operate a network of hundreds of Fridges, all stocked regularly with salads, sandwiches, breakfast items, and between-meal snacks.',
  pageTitle: 'Farmer’s Fridge',
  siteTitle: 'Farmer’s Fridge',
  url: 'https://farmersfridge.com',
  image: SEOImage,
};

/**
 * @param {Object.<string, any>} obj
 * @param {Object.<string, string>} defaults
 */
function mergeWithDefaults(obj, defaults) {
  const result = { ...defaults };
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * @param {FF.SEO} props
 *
 */
function SEO(props) {
  const attrs = mergeWithDefaults(props, {
    ...DEFAULTS,
  });

  const pageTitle = `${attrs.pageTitle}${
    attrs.pageTitle.includes('Farmer’s Fridge') ? '' : ` | Farmer’s Fridge`
  }`;

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={attrs.description} />
      <meta name="theme-color" content="#264810" />
      <link
        rel="icon"
        href="//cdn.shopify.com/s/files/1/0340/3549/9067/files/favicon_32x32.png?v=1584139401"
        type="image/png"
      />
      <meta property="og:site_name" content={attrs.siteTitle} />
      <meta property="og:url" content={attrs.url} />
      <meta property="og:title" content={attrs.pageTitle} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={attrs.description} />
      <meta property="og:image" content={attrs.image} />
      <meta property="og:image:secure_url" content={attrs.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={attrs.pageTitle} />
      <meta name="twitter:description" content={attrs.description} />
    </>
  );
}

export default SEO;
